import { BaseEdge, type EdgeProps } from '@xyflow/react';
import { useZipTieRoutedEdge } from './zipTieRouting';

/**
 * A plain edge that follows zip ties: no delete button, no editor state. Used
 * for read-only canvases and for derived wires (socket expressions).
 */
export function ZipTieEdge(props: EdgeProps) {
  const { path, labelX, labelY, bundled } = useZipTieRoutedEdge(props);
  const { style, markerStart, markerEnd, interactionWidth } = props;
  return (
    <BaseEdge
      path={path}
      labelX={labelX}
      labelY={labelY}
      label={props.label}
      labelStyle={props.labelStyle}
      labelShowBg={props.labelShowBg}
      labelBgStyle={props.labelBgStyle}
      labelBgPadding={props.labelBgPadding}
      labelBgBorderRadius={props.labelBgBorderRadius}
      markerStart={markerStart}
      markerEnd={markerEnd}
      interactionWidth={interactionWidth}
      style={bundled ? { ...style, stroke: '#2563eb', strokeWidth: 3 } : style}
    />
  );
}
